// eslint-disable-next-line import/no-unresolved
import * as env from 'env:config';

import { coerceEnvironment } from '@kinopoisk-int/kp-environment';

import type {
    ClientI18nConfig,
    ExternalLinksConfig,
    LanguageToSupportLinkMap,
    PaymentToolsConfig,
} from './types';

const i18n: ClientI18nConfig = {
    locales: [
        {
            name: 'ru',
            lang: 'ru',
            dir: 'ltr',
        },
        {
            name: 'en',
            lang: 'en',
            dir: 'ltr',
        },
        {
            name: 'uz',
            lang: 'uz',
            dir: 'ltr',
        },
    ],
    defaultLocale: {
        name: 'ru',
        lang: 'ru',
        dir: 'ltr',
    },
    localeDetectBrand: 'yandex',
    displayLanguages: [
        {
            code: 'ru',
            title: 'Русский',
            shortTitle: 'RU',
        },
        {
            code: 'en',
            title: 'English',
            shortTitle: 'EN',
        },
        {
            code: 'uz',
            title: 'O‘zbek',
            shortTitle: 'UZ',
        },
    ],
};

const paymentToolsConfig: PaymentToolsConfig = {
    serviceName: 'allplay',
    widgetServiceName: 'allplay',
    serviceChannelName: 'allplay_web',
    brand: 'YANDEX',
    theme: 'dark',
};

const clientSupportLinks: LanguageToSupportLinkMap = {
    en: 'https://allplay.uz/action/support',
    ru: 'https://allplay.uz/action/support',
    uz: 'https://allplay.uz/action/support',
};

const externalLinks = {
    music: null,
} satisfies ExternalLinksConfig;

export const clientConfig = {
    environment: coerceEnvironment(env.clientConfig.ENVIRONMENT),

    brandName: 'Allplay',
    appName: env.clientConfig.APP_NAME,
    appBrand: env.clientConfig.APP_BRAND,
    appVersion: env.clientConfig.APP_VERSION,
    serviceId: env.clientConfig.SERVICE_ID,
    productServiceName: env.clientConfig.PRODUCT_SERVICE_NAME,
    origin: env.clientConfig.ORIGIN,

    mockService: env.clientConfig.MOCK_SERVICE,
    graphQlPublicApi: env.clientConfig.GRAPHQL_API,
    idHost: env.clientConfig.ID_HOST,
    subscriptionHost: env.clientConfig.SUBSCRIPTION_HOST,
    passportHost: env.clientConfig.PASSPORT_HOST,
    paymentWidgetHost: env.clientConfig.PAYMENT_WIDGET_HOST,
    timingApiHost: env.clientConfig.TIMING_API_HOST,
    trackingsHost: env.clientConfig.TRACKINGS_HOST,
    saftGatewayApi: env.clientConfig.SAFT_GATEWAY_API,

    ottApiKpHost: '',

    authConfig: {
        passportUrl: env.clientConfig.AUTH_PASSPORT_URL,
        passportApiUrl: env.clientConfig.AUTH_PASSPORT_API_URL,
        origin: env.clientConfig.AUTH_CONFIG_ORIGIN,
        realHost: env.clientConfig.AUTH_CONFIG_REAL_HOST,
        authCookieName: 'Session_id',
        ssoHost: env.clientConfig.AUTH_SSO_HOST,
    },
    phoneAuthPassportUrl: env.clientConfig.PHONE_AUTH_PASSPORT_URL,

    i18n,

    defaultMeta: {
        ogImageUrl: env.clientConfig.DEFAULT_META_OG_IMAGE_URL,
        // https://wiki.yandex-team.ru/ott/frontend/OpenGraph/#izobrazhenija
        ogImageWidth: 1200,
        ogImageHeight: 630,
    },

    defaultMediaBillingConfig: {
        target: 'allplay-web',
    },
    paymentToolsConfig,
    channelsPaywall: {
        isEnabled: true,
        coverUrl:
            'https://avatars.mds.yandex.net/get-ott/12808873/2a0000019a6c7290f349aa1a27f01bb74c0b/orig',
        rtlCoverUrl:
            'https://avatars.mds.yandex.net/get-ott/12808873/2a0000019a6c7290f349aa1a27f01bb74c0b/orig',
    },
    promotionConfig: {
        version: '1.0',
        platform: 'web',
        consumer: 'allplay-general',
        profileChoosingConsumer: 'allplay-profile-choosing',
    },

    rumCounter: {
        project: env.clientConfig.RUM_COUNTER_PROJECT,
        service: env.clientConfig.RUM_COUNTER_SERVICE,
        desktopId: env.clientConfig.RUM_COUNTER_DESKTOP_ID,
        clck: env.clientConfig.RUM_COUNTER_CLCK,
    },
    yandexMetrika: {
        main: env.clientConfig.YANDEX_METRIKA_MAIN,
        scriptSrc: env.clientConfig.YANDEX_METRIKA_SCRIPT_SRC,
    },
    bughunter: {
        scriptHost: env.clientConfig.BUGHUNTER_SCRIPT_HOST,
    },
    gtm: {
        containerId: 'GTM-NRCML3CG',
        source: 'allplay-movies-www',
    },

    shouldUseConsoleLogger: env.clientConfig.SHOULD_USE_CONSOLE_LOGGER,

    isDevtoolsAvailable: env.clientConfig.DEVTOOLS_ENABLED,

    userIdConfig: {
        host: env.clientConfig.USER_ID_CONFIG_HOST,
        project: env.clientConfig.USER_ID_CONFIG_PROJECT,
        withGolden: env.clientConfig.USER_ID_CONFIG_WITH_GOLDEN,
    },

    socialNetworksLinks: [],

    clientSupportLinks,
    externalLinks,

    legalLink: env.clientConfig.LEGAL_LINK,

    playerTelemetryUrl: env.clientConfig.PLAYER_TELEMETRY_URL,
    playerPerfUrl: env.clientConfig.PLAYER_PERF_URL,

    filmoscopeBaseStaticPath: env.clientConfig.FILMOSCOPE_BASE_STATIC_PATH || undefined,
    filmoscopeYaspScriptUrl: env.clientConfig.FILMOSCOPE_YASP_SCRIPT_URL || undefined,

    isHeaderOfferButtonEnabled: false,
    isStyledShowcaseEnabled: true,
};
